module.exports = __webpack_public_path__ + "img/tanker_red.c098889b.svg";